<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-11-10 11:39:12
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Form_Sections.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-22 13:34:34
-->
<template>
  <v-card :class="ContainerClass + roundStyle" :elevation="elevation">
    <v-card-text :class="ContentClass">
      <slot name="default" />
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "Section",
  props: {
    ContentClass: {
      default: " pa-8 ",
      type: [String],
    },
    iSEdited: { default: false, type: [Boolean, Number] },
    isEnd: { default: false, type: [Boolean, Number] },
    isStart: { default: false, type: [Boolean, Number] },
    elevation: { default: 0, type: [String, Number] },
    ContainerClass: {
      default: " pa-0  ",
      type: [String],
    },
  },
  computed: {
    roundStyle() {
      let str = "";
      if (this.iSEdited) {
        //编辑状态
        if (this.isStart && this.isEnd) {
          str = " rounded-t-lg rounded-b-0 my-0 ";
        } else {
          if (this.isStart && !this.isEnd) {
            str = " rounded-lg mt-0 mb-8 ";
          } else if (!this.isStart && !this.isEnd) {
            str = "  rounded-lg my-8 ";
          } else {
            str = "  rounded-t-lg rounded-b-0 mt-8 mb-0 ";
          }
        }
      } else {
        //查看状态
        if (this.isStart && this.isEnd) {
          str = "rounded-lg my-0";
        } else {
          if (this.isStart && !this.isEnd) {
            str = " rounded-lg mt-0 mb-8 ";
          } else {
            str = "  rounded-lg my-8 ";
          }
        }
      }
      // if (this.isStart && this.isEnd) {
      //   str = "rounded-lg my-0";
      // } else {
      // }
      // if (this.isEnd && this.iSEdited) str = " rounded-t-lg rounded-b-0 mt-8  ";
      // else str = "rounded-lg my-8";
      // if (this.isStart && this.iSEdited) str = "rounded-lg mb-8";

      return str;
    },
  },
  data() {
    return {};
  },
};
</script>